import { Component, Mixins } from "vue-property-decorator";
import {
  Contract,
  ContractStatus,
  SchemeType
} from "@foxone/api/src/models/defi";
import { CreateElement, VNode } from "vue/types/umd";
import { VContainer } from "vuetify/lib";
import utils from "defi/utils";
import NormalListItem from "defi/components/contracts/list/NormalListItem.vue";
import TermListItem from "defi/components/contracts/list/TermListItem.vue";
import mixins from "@/mixins";

@Component
class ContractsPage extends Mixins(mixins.scrollAppbarPage) {
  contracts: Contract[] = [];

  loading = false;

  get title() {
    return this.getTypeText(this.type);
  }

  get type() {
    return this.$route.params.type as SchemeType;
  }

  getTypeText(type: SchemeType) {
    return this.$t(utils.enums.getSchemeTypeMeta(type).text) as string;
  }

  mounted() {
    return this.requestContracts();
  }

  async requestContracts() {
    const actions = this.$api.defi.getActionsBySchemeType(
      this.type as SchemeType
    );
    this.loading = true;
    const status = [
      ContractStatus.SIGNED,
      ContractStatus.RUNNING,
      ContractStatus.SETTLEMENT,
      ContractStatus.REDEMPTION,
      ContractStatus.CLOSED
    ];
    try {
      this.contracts = await actions.getContracts({ status: status.join(",") });
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.loading = false;
  }

  genContractItem(type: SchemeType, contract: Contract) {
    const h = this.$createElement;

    if (type === SchemeType.TERM) {
      return h(TermListItem, { props: { contract } });
    }
    return h(NormalListItem, { props: { contract } });
  }

  render(h: CreateElement): VNode {
    const contracts = this.contracts.map(item =>
      this.genContractItem(this.type, item)
    );

    return h("base-top-banner-page", {
      scopedSlots: {
        content: () => {
          return [
            h("div", { staticClass: "pa-4 pb-0 font-weight-bold" }, [
              this.appbar.title
            ]),
            h(VContainer, contracts)
          ];
        }
      }
    });
  }
}

export default ContractsPage;
